export default {
  "vlist.menu": {
    root: "relative inline-block",
    root_item: "flex items-center text-[17px] leading-tight font-normal text-text hover:text-primary whitespace-nowrap transition duration-200 cursor-pointer px-2 py-2 mt-[2px] xl:mt-0",
    submenu:
      "absolute top-full mt-5 p-8 bg-paper shadow-lg rounded-[27px] z-10",
    menu: "list-none space-y-5 p-0 m-0",
    submenu_item_offset: "ml-5 mt-5",
    menu_column: "border-none",
    menu_item:
     "hover:bg-none flex flex-col p-0 m-1 items-left justify-between rounded-md cursor-pointer text-primary",
  },

  //used in language selector in header
  "mobilingo_vlist.menu_bordered": {
    root: "relative inline-block group", 
    root_item: "flex items-center text-[17px] leading-tight font-normal text-text hover:text-primary transition duration-200 cursor-pointer px-2 py-2",
    submenu: "absolute top-full mt-5 pr-1 py-7 bg-paper shadow-lg rounded-[27px] z-10",
    menu: "list-none space-y-8 p-0 m-0",
    submenu_item_offset: "ml-0 mt-5",
    menu_column: "ml-2 pl-10 first:border-l-0 border-l border-bordered", //adds left border to all except first columns
    menu_item: "hover:bg-none flex flex-col px-0 py-0 my-0 items-left justify-between rounded-md cursor-pointer text-[17px] leading-tight font-normal text-text hover:text-primary transition duration-200",
  },

  "hlist.icons": {
    menu: "flex flex-col md:flex-row items-center gap-5 py-0 my-0",
    menu_item: "py-0 my-0",
  },

  hlist: {
    menu: "flex items-center gap-5 my-0",
    menu_item: "flex items-center text-text list-none px-4 py-2 my-0",
  },

  mobilingo_hlist_follow: {
    menu: "flex items-center gap-1 my-0",
    menu_item: "flex items-center list-none text-text pr-1 xl:pr-[6px] py-0  my-0",
  },

  mobilingo_hlist_hamburger: {
    menu: "h-[72px] flex items-center py-0 my-0",
    menu_item:
      "flex items-center rounded-md text-text list-none px-4 py-0 my-0",
  },
}
